import { ref, readonly, type Ref } from "vue";

export interface Notification {
  id: string;
  type: "success" | "error" | "warning" | "info";
  title?: string;
  message?: string;
  duration?: number; // Duration in ms. Set to 0 for infinite.
}

// State is defined outside the function scope to be global (Singleton pattern for composable)
const notifications = ref<Notification[]>([]);
let idCounter = 0;

export function useNotifications() {
  const addNotification = (notification: Omit<Notification, "id">) => {
    idCounter++;
    const id = `notif-${idCounter}-${Date.now()}`;

    // Add to the list
    notifications.value.push({
      ...notification,
      id,
    });

    // Note: Automatic removal is handled by the BaseNotification component's timer
    // to allow for pause-on-hover functionality.
  };

  const removeNotification = (id: string) => {
    const index = notifications.value.findIndex((n) => n.id === id);
    if (index !== -1) {
      notifications.value.splice(index, 1);
    }
  };

  const clearNotifications = () => {
    notifications.value = [];
  };

  return {
    notifications: readonly(notifications) as Readonly<Ref<Notification[]>>,
    addNotification,
    removeNotification,
    clearNotifications,
  };
}
